
import { Icon } from '@/shared/ui'
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'RollDifficulty',
	components: { Icon },
	emits: ['update:modelValue'],
	props: {
		modelValue: {
			type: Number,
			required: true
		}
	},
	methods: {
		setDifficulty(value: number) {
			this.$emit('update:modelValue', value)
		}
	}
})
